
import { BusinessUnitEntityDecoratorBase } from './business-unit.decorator.base';


export class BusinessUnitEntityDecorator extends BusinessUnitEntityDecoratorBase {
  constructor() {
    super();
  }
}



